module.exports = __webpack_public_path__ + "img/jordan.9ad3ff65.svg";